import api from './api';

export const ticketService = {
  // Количество заявок по статусам
  getQuestCountsByStatus: async () => {
    const response = await api.get('/api/dispatcher/quests/counts-by-status');
    return response.data;
  },

  // Получение списка заявок по статусу
  getTickets: async (page = 1, pageSize = 10, statusCode) => {
    if (statusCode === undefined || statusCode === null) {
      throw new Error('statusCode is required for getTickets');
    }
    try {
      const response = await api.get('/api/dispatcher/quests', {
        params: {
          Page: page,
          PageSize: pageSize,
          Statuses: statusCode,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Получение детальной информации о заявке
  getTicket: async (ticketId) => {
    try {
      const response = await api.get(`/api/dispatcher/quests/${ticketId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Обновление заявки
  updateTicket: async (ticketId, ticketData) => {
    try {
      const { statusId, ...apiData } = ticketData;
      const response = await api.put(`/api/dispatcher/quests/${ticketId}`, apiData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Отмена заявки
  cancelTicket: async (ticketId) => {
    try {
      const response = await api.post(`/api/dispatcher/quests/${ticketId}/cancel`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Получение статусов заявок (если есть такой эндпоинт)
  getStatuses: async () => {
    return [
      { id: '0', name: 'Новая' },
      { id: '1', name: 'Назначена' },
      { id: '2', name: 'В работе' },
      { id: '3', name: 'Завершена' },
      { id: '4', name: 'Отменена' },
    ];
  },

  // Получение категорий заявок (если есть такой эндпоинт)
  getCategories: async () => {
    return [
      { id: '1', name: 'Ремонт сантехники' },
      { id: '2', name: 'Электрика' },
      { id: '3', name: 'Отопление' },
      { id: '4', name: 'Строительные работы' },
    ];
  },

  // Получение списка услуг
  getServices: async () => {
    try {
      const response = await api.get('/api/dispatcher/services');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Создание услуги
  createService: async (serviceData) => {
    try {
      const response = await api.post('/api/dispatcher/services', serviceData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Обновление услуги
  updateService: async (serviceId, serviceData) => {
    try {
      const response = await api.put(`/api/dispatcher/services/${serviceId}`, serviceData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Удаление услуги
  deleteService: async (serviceId) => {
    try {
      const response = await api.delete(`/api/dispatcher/services/${serviceId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Получение списка мастеров
  getMasters: async () => {
    try {
      const response = await api.get('/api/dispatcher/masters');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  uploadAttachment: async (questId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/api/dispatcher/quests/${questId}/upload-attachment`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  uploadNewQuestAttachment: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/api/dispatcher/quests/upload-attachment-newquest', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Удаление вложения
  deleteAttachment: async (questId, attachmentId) => {
    try {
      const response = await api.delete(`/api/dispatcher/quests/${questId}/attachments/${attachmentId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Создание заявки
  createTicket: async (ticketData) => {
    try {
      console.log('API call: POST /api/dispatcher/quests');
      console.log('API data:', ticketData);
      const response = await api.post('/api/dispatcher/quests', ticketData);
      return response.data;
    } catch (error) {
      console.error('API error:', error);
      if (error.response) {
        console.error('API error response:', error.response.data);
      }
      throw error;
    }
  },

  // Получение заявок по ID обращения (ticketId из Domokey)
  getQuestsByTicket: async (ticketId) => {
    try {
      const response = await api.get(`/api/dispatcher/quests/by-ticket/${ticketId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Создание мастера
  createMaster: async (masterData) => {
    try {
      const response = await api.post('/api/dispatcher/masters', masterData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Обновление мастера
  updateMaster: async (masterId, masterData) => {
    try {
      const response = await api.put(`/api/dispatcher/masters/${masterId}`, masterData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Удаление мастера
  deleteMaster: async (masterId) => {
    try {
      const response = await api.delete(`/api/dispatcher/masters/${masterId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};